import Offcanvas from 'react-bootstrap/Offcanvas';
import './genericOffCanvas.css'
import { useToggle } from '../../../context/toggle/toggleBtn';




export const GenericOffCanvas = ({ placement, children, OCStyle, OCHeaderStyle,closeButton,OCBodyStyle }) => {

  const { isActive, toggleBTN, toggleClose } = useToggle()

  return (
    <>


      <Offcanvas
        show={isActive}
        onHide={toggleClose}
        // onHide={toggleBTN}
        placement={placement}
        className={OCStyle}

      >
        {closeButton ? 
        <Offcanvas.Header
          closeButton
          className='OC-title'>

          <Offcanvas.Title >Menú</Offcanvas.Title>
        </Offcanvas.Header>
        :null}
        

        <Offcanvas.Body 
        className={OCBodyStyle}>

          <>{children}</>

        </Offcanvas.Body>
      </Offcanvas >
    </>
  )
}


